<template>
  <svg width="6" height="14" viewBox="0 0 6 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path id="Rectangle 24_2" d="M4.97932 7L0.75 11.5818V2.41824L4.97932 7Z" stroke="#D30101" stroke-width="1.5"/>
  </svg>
</template>